export const MAX_UPLOAD_FILE_NAME_LENGTH = 255;

// Shortens a file name to the backend limit and keeps its extension. Counts code points,
// as the backend does, so a character outside the BMP (an emoji) is never cut in half.
const toUploadFileName = (fileName: string): string => {
  const chars = Array.from(fileName);

  if (chars.length <= MAX_UPLOAD_FILE_NAME_LENGTH) {
    return fileName;
  }

  const extensionStart = fileName.lastIndexOf('.');
  const extension = extensionStart > 0 ? Array.from(fileName.slice(extensionStart)) : [];
  const stemLength = MAX_UPLOAD_FILE_NAME_LENGTH - extension.length;

  if (stemLength < 1) {
    return chars.slice(0, MAX_UPLOAD_FILE_NAME_LENGTH).join('');
  }

  return [...chars.slice(0, stemLength), ...extension].join('');
};

export default toUploadFileName;
